import AntIcon from "@/components/icons/AntIcon";
import { resolveFormValidationError, skipInitialFormValues } from "@/utils/formUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validations } from "@/utils/validationUtils";
import { Button, Col, Form, Input, Radio, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { rowGutter } from "../../../../../../common/constants";
import { SpecialCommissionsReport } from "../../../../special/enums";
import { SpecialCommissionsFilterPageRequest } from "../../../../special/types";
import { DEFAULT_FILTER_SPECIAL_COMMISSIONS_QUERY_PARAMS } from "../../../api";

const colSpan = 6;

type Props = {
  searchParams: SpecialCommissionsFilterPageRequest;
};

export const BatchSpecialCommissionFilterForm = ({ searchParams }: Props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [form] = Form.useForm<SpecialCommissionsFilterPageRequest>();

  useEffect(() => {
    form.setFieldsValue({ ...searchParams, code: searchParams.code?.toString() });
  }, [searchParams, form]);

  const handleFilterSubmit = (filter: SpecialCommissionsFilterPageRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: {
            ...skipInitialFormValues(filter, DEFAULT_FILTER_SPECIAL_COMMISSIONS_QUERY_PARAMS),
            pageIndex: undefined,
          },
        }),
      },
      { replace: true },
    );
  };

  const handleReportSwitch = (report: SpecialCommissionsReport) => {
    form
      .validateFields()
      .then((values) => handleFilterSubmit({ ...values, report }))
      .catch(resolveFormValidationError);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => handleFilterSubmit({ ...values, report: searchParams.report })}
      name="batchSpecialCommissionFilterForm"
    >
      <Row gutter={rowGutter} justify="center" className="margin-bottom-medium">
        <Col span={24} className="center-align">
          <Radio.Group
            size="large"
            buttonStyle="solid"
            value={searchParams.report ?? SpecialCommissionsReport.INCLUDED}
            onChange={(e) => handleReportSwitch(e.target.value)}
          >
            <Radio.Button value={SpecialCommissionsReport.INCLUDED}>
              {t("commissions.special.enums.report.INCLUDED")}
            </Radio.Button>
            <Radio.Button value={SpecialCommissionsReport.EXCLUDED}>
              {t("commissions.special.enums.report.EXCLUDED")}
            </Radio.Button>
          </Radio.Group>
        </Col>
      </Row>

      <Row gutter={rowGutter} justify="center">
        <Col span={colSpan}>
          <Form.Item name="code" label={t("commissions.special.attrs.code")} rules={[validations.size(1, 16)]}>
            <Input allowClear placeholder={t("commissions.batch.helpers.specialCommissionCodePlaceholder")} />
          </Form.Item>
        </Col>

        <Col flex="110px" className="no-title-space">
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
              {t("common.filter")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
